import React, { useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import SeletorGE from '~/Components/SeletorGE';
import { listarContasSaldoBanco, obterCotacoesAtual } from '~/Services/Service';

const OPCOES_LIQUIDEZ = [
  { value: 0, label: 'Todos' },
  { value: 1, label: 'Alta liquidez' },
  { value: 2, label: 'Baixa liquidez' },
];

const OPCOES_QUAL_DATA = [
  { value: 'N', label: 'Data do Negócio' },
  { value: 'C', label: 'Data Contábil' },
];

const Filtros = ({
  modo,
  values,
  errors,
  touched,
  setFieldValue,
  handleChange,
  handleBlur,
  grupos,
  moedas,
}) => {
  const [carregandoCotacoes, setCarregandoCotacoes] = useState(false);
  const [contas, setContas] = useState([]);
  const [carregandoContas, setCarregandoContas] = useState(false);

  const moedaRefSelecionada = moedas.find((m) => m.codigo_ativo === values.codigoMoedaReferencia) || null;
  const formatarMoedaLabel = (moeda) => `${moeda.codigo_ativo} - ${moeda.nome}`;
  const opcoesMoedas = moedas.map((m) => ({ value: m.codigo_ativo, label: formatarMoedaLabel(m) }));
  const moedasOutras = moedas.filter((m) => m.codigo_ativo !== values.codigoMoedaReferencia);
  const formatarContaLabel = (conta) => `${conta.codigo_conta} - ${conta.apelido_conta}`;
  const opcoesContas = contas.map((c) => ({ value: c.codigo_conta, label: formatarContaLabel(c) }));
  const contaSelecionada = contas.find((c) => c.codigo_conta === values.contaEspecifica) || null;
  const codigosSaldos = Array.isArray(values.codigosGrupoEmpresa) ? values.codigosGrupoEmpresa : [];
  const codigoGrupoEmpresaContas =
    modo === 'extrato'
      ? values.codigoGrupoEmpresa
      : (codigosSaldos.length === 1 ? codigosSaldos[0] : null);
  const placeholderConta =
    modo === 'saldos' && codigosSaldos.length !== 1
      ? 'Selecione um único GE'
      : 'Todas';
  const codigosGrupoEmpresaKey = codigosSaldos.join(',');

  useEffect(() => {
    if (!values.codigoMoedaReferencia || moedasOutras.length === 0) return;

    let ativo = true;
    const ativos = moedasOutras.map((m) => m.codigo_ativo);

    const buscarCotacoes = async () => {
      setCarregandoCotacoes(true);
      try {
        const res = await obterCotacoesAtual(ativos);
        if (!ativo) return;
        const lista = Array.isArray(res) ? res : (res && res.data ? res.data : []);
        const novasCotacoes = { ...values.cotacoes };
        lista.forEach((c) => {
          if (novasCotacoes[c.codigo_ativo] === undefined) {
            novasCotacoes[c.codigo_ativo] = c.valor;
          }
        });
        setFieldValue('cotacoes', novasCotacoes);
      } catch (err) {
        if (!ativo) return;
        const msg = err && err.message ? err.message : 'Erro ao buscar cotações.';
        toast.error(msg);
      } finally {
        if (ativo) setCarregandoCotacoes(false);
      }
    };

    buscarCotacoes();

    return () => { ativo = false; };
  }, [values.codigoMoedaReferencia]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let ativo = true;
    setFieldValue('contaEspecifica', null);
    setContas([]);

    if (!codigoGrupoEmpresaContas) {
      setCarregandoContas(false);
      return;
    }

    const buscarContas = async () => {
      setCarregandoContas(true);
      try {
        const res = await listarContasSaldoBanco(codigoGrupoEmpresaContas);
        if (!ativo) return;
        const lista = Array.isArray(res) ? res : (res && res.data ? res.data : []);
        setContas(lista);
      } catch (err) {
        if (!ativo) return;
        const msg = err && err.message ? err.message : 'Erro ao buscar contas.';
        toast.error(msg);
      } finally {
        if (ativo) setCarregandoContas(false);
      }
    };

    buscarContas();

    return () => { ativo = false; };
  }, [modo, values.codigoGrupoEmpresa, codigosGrupoEmpresaKey]); // eslint-disable-line react-hooks/exhaustive-deps

  if (modo === 'extrato') {
    return (
      <Card className="mb-3">
        <Card.Header><strong>Filtros — Extrato de Caixa</strong></Card.Header>
        <Card.Body>
          <Row>
            <Col xs={12} md={6} lg={3}>
              <Form.Group>
                <Form.Label>Data Inicial <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="date"
                  name="dataInicial"
                  value={values.dataInicial}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.dataInicial && !!errors.dataInicial}
                />
                {touched.dataInicial && errors.dataInicial && (
                  <Form.Control.Feedback type="invalid">{errors.dataInicial}</Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={3}>
              <Form.Group>
                <Form.Label>Data Final <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="date"
                  name="dataFinal"
                  value={values.dataFinal}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={touched.dataFinal && !!errors.dataFinal}
                />
                {touched.dataFinal && errors.dataFinal && (
                  <Form.Control.Feedback type="invalid">{errors.dataFinal}</Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={3}>
              <Form.Group>
                <Form.Label>Tipo de Data <span className="text-danger">*</span></Form.Label>
                <Select
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  options={OPCOES_QUAL_DATA}
                  value={OPCOES_QUAL_DATA.find((o) => o.value === values.qualData) || null}
                  onChange={(opt) => setFieldValue('qualData', opt ? opt.value : 'N')}
                  isClearable={false}
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={3}>
              <Form.Group>
                <Form.Label>Grupo de Empresa</Form.Label>
                <SeletorGE
                  grupos={grupos}
                  value={values.codigoGrupoEmpresa}
                  onChange={(v) => setFieldValue('codigoGrupoEmpresa', v)}
                  isMulti={false}
                  placeholder="Todos os GEs"
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={3}>
              <Form.Group>
                <Form.Label>Conta Específica</Form.Label>
                <Select
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  options={opcoesContas}
                  value={contaSelecionada
                    ? { value: contaSelecionada.codigo_conta, label: formatarContaLabel(contaSelecionada) }
                    : null}
                  onChange={(opt) => setFieldValue('contaEspecifica', opt ? opt.value : null)}
                  isClearable
                  isDisabled={!codigoGrupoEmpresaContas || carregandoContas}
                  isLoading={carregandoContas}
                  placeholder={values.codigoGrupoEmpresa ? 'Todas' : 'Selecione um GE'}
                  noOptionsMessage={() => 'Nenhuma conta disponível'}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mb-3">
      <Card.Header><strong>Filtros — Saldos</strong></Card.Header>
      <Card.Body>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group>
              <Form.Label>Grupos de Empresa <span className="text-danger">*</span></Form.Label>
              <SeletorGE
                grupos={grupos}
                value={values.codigosGrupoEmpresa}
                onChange={(v) => setFieldValue('codigosGrupoEmpresa', v)}
              />
              {touched.codigosGrupoEmpresa && errors.codigosGrupoEmpresa && (
                <div className="text-danger small mt-1">{errors.codigosGrupoEmpresa}</div>
              )}
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <Form.Group>
              <Form.Label>Moeda de Referência <span className="text-danger">*</span></Form.Label>
              <Select
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={opcoesMoedas}
                value={moedaRefSelecionada
                  ? { value: moedaRefSelecionada.codigo_ativo, label: formatarMoedaLabel(moedaRefSelecionada) }
                  : null}
                onChange={(opt) => {
                  setFieldValue('codigoMoedaReferencia', opt ? opt.value : null);
                  setFieldValue('cotacoes', {});
                }}
                placeholder="Selecione a moeda..."
                isClearable={false}
                isInvalid={touched.codigoMoedaReferencia && !!errors.codigoMoedaReferencia}
              />
              {touched.codigoMoedaReferencia && errors.codigoMoedaReferencia && (
                <div className="text-danger small mt-1">{errors.codigoMoedaReferencia}</div>
              )}
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={3}>
            <Form.Group>
              <Form.Label>Liquidez</Form.Label>
              <Select
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={OPCOES_LIQUIDEZ}
                value={OPCOES_LIQUIDEZ.find((o) => o.value === values.liquidez) || OPCOES_LIQUIDEZ[0]}
                onChange={(opt) => setFieldValue('liquidez', opt ? opt.value : 0)}
                isClearable={false}
              />
            </Form.Group>
          </Col>

        </Row>

        <Row>
          <Col xs={12} md={6} lg={4}>
            <Form.Group>
              <Form.Label>Conta Específica</Form.Label>
              <Select
                styles={customStyles}
                components={{ DropdownIndicator }}
                options={opcoesContas}
                value={contaSelecionada
                  ? { value: contaSelecionada.codigo_conta, label: formatarContaLabel(contaSelecionada) }
                  : null}
                onChange={(opt) => setFieldValue('contaEspecifica', opt ? opt.value : null)}
                isClearable
                isDisabled={!codigoGrupoEmpresaContas || carregandoContas}
                isLoading={carregandoContas}
                placeholder={placeholderConta}
                noOptionsMessage={() => 'Nenhuma conta disponível'}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <Form.Group>
              <Form.Check
                type="checkbox"
                id="chk-participacao-societaria"
                label="Incluir Participação Societária"
                checked={values.participacaoSocietaria}
                onChange={(e) => setFieldValue('participacaoSocietaria', e.target.checked)}
                className="mt-4"
              />
            </Form.Group>
          </Col>
        </Row>

        {moedasOutras.length > 0 && values.codigoMoedaReferencia && (
          <>
            <hr />
            <Row>
              <Col xs={12}>
                <Form.Label className="font-weight-bold">
                  Cotações{' '}
                  {carregandoCotacoes && (
                    <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true" />
                  )}
                </Form.Label>
              </Col>
              {moedasOutras.map((moeda) => (
                <Col key={moeda.codigo_ativo} xs={12} sm={6} md={4} lg={3}>
                  <Form.Group>
                    <Form.Label className="small">{formatarMoedaLabel(moeda)}</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.000001"
                      min="0"
                      value={values.cotacoes[moeda.codigo_ativo] !== undefined ? values.cotacoes[moeda.codigo_ativo] : ''}
                      onChange={(e) =>
                        setFieldValue('cotacoes', {
                          ...values.cotacoes,
                          [moeda.codigo_ativo]: e.target.value !== '' ? Number(e.target.value) : undefined,
                        })
                      }
                      placeholder="0,000000"
                    />
                  </Form.Group>
                </Col>
              ))}
            </Row>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default Filtros;
